import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import AuthorizedRoute from '../../shared/authorization/authorizedRoute';

const AuthorizedComplianceRoute = ({
  component: Component,
  globalContextDropdowns = null,

  ...routeRest
}) => {
  const routeRender = useCallback(
    props => (
      <>
        <Component {...props} />
        {globalContextDropdowns}
      </>
    ),
    [globalContextDropdowns],
  );

  return <AuthorizedRoute render={routeRender} {...routeRest} />;
};

AuthorizedComplianceRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  globalContextDropdowns: PropTypes.element,
};

export default AuthorizedComplianceRoute;
